<template>
  <q-page padding>
    <PageHeader
      title="Criação de Capacitação por Planilha"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="capacitacao" label="Criação de Capacitação" />
      <q-tab name="associacao" label="Associação de Produtos" />
      <q-tab name="treinamento" label="Criação de treinamento" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <!-- ===== CRIAÇÃO DE CAPACITAÇÃO ===== -->
      <q-tab-panel name="capacitacao">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Criação de Capacitação
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="informacao = true"
            />
          </p>
        </div>

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select v-model="unidade.nome" />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de criação de capacitação
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file, 'drag-over': isDragOver1 }"
              @dragover.prevent="isDragOver1 = true"
              @dragleave.prevent="isDragOver1 = false"
              @drop.prevent="onDrop('file', $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{ file.name }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file ? 'positive' : 'primary'"
                      :icon="file ? 'check_circle' : 'folder_open'"
                      :label="
                        file ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput1.click()"
                    />
                    <input
                      ref="fileInput1"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected('file', e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file"
                @click="enviarArquivo"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== ASSOCIAÇÃO DE PRODUTOS ===== -->
      <q-tab-panel name="associacao">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Associação de Produtos
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="informacaoAssociacaoGrupos = true"
            />
          </p>
        </div>

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select v-model="unidade.nome" />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de associação de produtos
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{
                'file-selected': fileAssociacaoGrupos,
                'drag-over': isDragOver2,
              }"
              @dragover.prevent="isDragOver2 = true"
              @dragleave.prevent="isDragOver2 = false"
              @drop.prevent="onDrop('fileAssociacaoGrupos', $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!fileAssociacaoGrupos">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      fileAssociacaoGrupos.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="fileAssociacaoGrupos ? 'positive' : 'primary'"
                      :icon="
                        fileAssociacaoGrupos ? 'check_circle' : 'folder_open'
                      "
                      :label="
                        fileAssociacaoGrupos
                          ? 'Arquivo Selecionado'
                          : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput2.click()"
                    />
                    <input
                      ref="fileInput2"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected('fileAssociacaoGrupos', e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="fileAssociacaoGrupos">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho:
                    {{ formatFileSize(fileAssociacaoGrupos.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ fileAssociacaoGrupos.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!fileAssociacaoGrupos"
                @click="enviarArquivoAssociacaoGrupos"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== CRIAÇÃO DE TREINAMENTO ===== -->
      <q-tab-panel name="treinamento">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Criação de treinamento
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="informacaoTreinamento = true"
            />
          </p>
        </div>

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select v-model="unidade.nome" />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de criação de treinamento
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{
                'file-selected': fileTreinamento,
                'drag-over': isDragOver3,
              }"
              @dragover.prevent="isDragOver3 = true"
              @dragleave.prevent="isDragOver3 = false"
              @drop.prevent="onDrop('fileTreinamento', $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!fileTreinamento">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      fileTreinamento.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="fileTreinamento ? 'positive' : 'primary'"
                      :icon="fileTreinamento ? 'check_circle' : 'folder_open'"
                      :label="
                        fileTreinamento
                          ? 'Arquivo Selecionado'
                          : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput3.click()"
                    />
                    <input
                      ref="fileInput3"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected('fileTreinamento', e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="fileTreinamento">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(fileTreinamento.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ fileTreinamento.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!fileTreinamento"
                @click="enviarArquivoTreinamento"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>

    <!-- ===== DIALOGS DE INFORMAÇÃO ===== -->
    <q-dialog v-model="informacao">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/padrao_treinamento_em_massa_r1.xlsx"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                Clique no icone para baixar o modelo mais atualizado do template
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="1" class="column no-wrap flex-center">
              <q-icon name="do_not_disturb" size="56px" />
              <div class="q-mt-md text-center">
                Não altere a ordem das colunas nem o texto, isso trará problema
                na importação
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="2" class="column no-wrap flex-center">
              <q-icon name="delete" size="56px" />
              <div class="q-mt-md text-center">
                APAGUE as informações da linha 2 e preencha com seus valores
                reais
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="3" class="column no-wrap flex-center">
              <q-icon name="view_column" size="56px" />
              <div class="q-mt-md text-center">
                A coluna A (sap) refere-se ao ID do colaborador
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="4" class="column no-wrap flex-center">
              <q-icon name="do_not_disturb" size="56px" />
              <div class="q-mt-md text-center">
                Se houver erro de digitação na coluna B (treinamento) o sistema
                irá criar outro treinamento com esse "novo" nome.
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="5" class="column no-wrap flex-center">
              <q-icon name="event" size="56px" />
              <div class="q-mt-md text-center">
                A validade do treinamento é em dias.
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>

    <q-dialog v-model="informacaoAssociacaoGrupos">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slideAssocoacaoGrupos"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/treinamento/Associacao_de_Pessoas_vs_Treinamentos.xlsx"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                Clique no icone para baixar o modelo mais atualizado do template
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>

    <q-dialog v-model="informacaoTreinamento">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/treinamento/Criacao_Treinamentos.xlsx"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                Clique no icone para baixar o modelo mais atualizado do template
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="1" class="column no-wrap flex-center">
              <q-icon name="do_not_disturb" size="56px" />
              <div class="q-mt-md text-center">
                Não altere a ordem das colunas nem o texto, isso trará problema
                na importação
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="2" class="column no-wrap flex-center">
              <q-icon name="delete" size="56px" />
              <div class="q-mt-md text-center">
                APAGUE as informações da linha 2 e preencha com seus valores
                reais
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="3" class="column no-wrap flex-center">
              <q-icon name="event" size="56px" />
              <div class="q-mt-md text-center">
                A validade do treinamento é em dias.
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const $q = useQuasar();

    const unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });

    const file = ref(null);
    const fileAssociacaoGrupos = ref(null);
    const fileTreinamento = ref(null);

    const fileInput1 = ref(null);
    const fileInput2 = ref(null);
    const fileInput3 = ref(null);

    const isDragOver1 = ref(false);
    const isDragOver2 = ref(false);
    const isDragOver3 = ref(false);

    const informacao = ref(false);
    const informacaoAssociacaoGrupos = ref(false);
    const informacaoTreinamento = ref(false);

    const slide = ref(0);
    const slideAssocoacaoGrupos = ref(0);

    const fileRefs = { file, fileAssociacaoGrupos, fileTreinamento };

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelected = (key, e) => {
      if (e.target.files[0]) fileRefs[key].value = e.target.files[0];
    };

    const onDrop = (key, e) => {
      const dragRefs = {
        file: isDragOver1,
        fileAssociacaoGrupos: isDragOver2,
        fileTreinamento: isDragOver3,
      };
      dragRefs[key].value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        fileRefs[key].value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const readAsBase64 = (f) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(f);
        reader.onload = () => resolve(reader.result.split("base64,")[1]);
        reader.onerror = () => reject(reader.error);
      });

    const enviarArquivo = async () => {
      if (!file.value || !file.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }
      $q.loading.show({ message: "Enviando planilha..." });
      try {
        const arquivo = await readAsBase64(file.value);
        await store.dispatch("treinamento/uploadCapacitacao", {
          unidadeId: unidade.value.id,
          arquivo,
        });
        $q.loading.hide();
        $q.notify({
          message: "Upload feito com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        file.value = null;
      } catch (error) {
        $q.loading.hide();
        console.log(error);
        $q.notify({
          message: "Erro ao fazer upload",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const enviarArquivoAssociacaoGrupos = async () => {
      if (
        !fileAssociacaoGrupos.value ||
        !fileAssociacaoGrupos.value.name.endsWith(".xlsx")
      ) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }
      $q.loading.show({ message: "Enviando planilha..." });
      try {
        const arquivo = await readAsBase64(fileAssociacaoGrupos.value);
        await store.dispatch("treinamento/uploadAssociacaoMassa", {
          unidadeId: unidade.value.id,
          arquivo,
        });
        $q.loading.hide();
        $q.notify({
          message: "Upload feito com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        fileAssociacaoGrupos.value = null;
      } catch (error) {
        $q.loading.hide();
        console.log(error);
        $q.notify({
          message: "Erro ao fazer upload",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const enviarArquivoTreinamento = async () => {
      if (
        !fileTreinamento.value ||
        !fileTreinamento.value.name.endsWith(".xlsx")
      ) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }
      $q.loading.show({ message: "Enviando planilha..." });
      try {
        const arquivo = await readAsBase64(fileTreinamento.value);
        await store.dispatch("treinamento/uploadTreinamento", {
          unidadeId: unidade.value.id,
          arquivo,
        });
        $q.loading.hide();
        $q.notify({
          message: "Upload feito com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        fileTreinamento.value = null;
      } catch (error) {
        $q.loading.hide();
        console.log(error);
        $q.notify({
          message: "Erro ao fazer upload",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    const getUnidade = () => {
      if (localStorage.unidade && localStorage.unidade !== "null") {
        unidade.value.nome = JSON.parse(localStorage.getItem("unidade"));
      }
    };

    onMounted(getUnidade);

    return {
      unidade,
      tab: ref("capacitacao"),
      file,
      fileAssociacaoGrupos,
      fileTreinamento,
      fileInput1,
      fileInput2,
      fileInput3,
      isDragOver1,
      isDragOver2,
      isDragOver3,
      informacao,
      informacaoAssociacaoGrupos,
      informacaoTreinamento,
      slide,
      slideAssocoacaoGrupos,
      formatFileSize,
      onFileSelected,
      onDrop,
      enviarArquivo,
      enviarArquivoAssociacaoGrupos,
      enviarArquivoTreinamento,
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}

.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}

.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}

.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

a {
  text-decoration: none;
  color: white;
}
</style>
